import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import '../style/finalReport.css';
import { ButtonComponent } from '../component/Common';
import Swal from 'sweetalert2';
import { useLocation, useNavigate, useParams } from "react-router-dom";


const FinalReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const applicationId = searchParams.get('applicationId');
  const [requirementData, setRequirementData] = useState(null);

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async (id) => {
      try {
        const response = await api.get(`/final-report/${id}`);
        if (response.status == 200) {
          setData(response.data.userData);
          setRequirementData(response.data.requirementData);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData(applicationId);
  }, []);

  let formStatus;
  const handleFormSubmission = async () => {
    const response = await Swal.fire({
      icon: "question",
      text: "Are you sure you want to submit the form? Please review all the details carefully before final submission, as you won’t be able to make changes afterward.",
      iconColor: '#AB1717',
      showConfirmButton: true,
      confirmButtonText: "Final Submission",
      confirmButtonColor: "#0E2F4F",
      showCancelButton: true,
      cancelButtonText: "Cancel",
    });
    formStatus = response.isConfirmed ? "Submit" : "Edit";

    try {
      const result = await api.post(`/final-submission/${applicationId}`, { formStatus });
      if (result.status === 200) {
        if (formStatus === "Submit") {
          navigate('/mortgage_dashboard');
        }
      } else {
        console.error("Unexpected response from server", result);
      }
    } catch (error) {
      console.error("Final submission error", error);
    }
  };

  const saveFormData = async () => {
    try {
      formStatus = "Edit";
      const result = await api.post(`/final-submission/${applicationId}`, { formStatus });
      if (result.status === 200) {
        if (formStatus === "Edit") {
          Swal.fire({
            icon: 'info',
            iconColor: '#387CF6',
            title: "Form not submitted!",
            text: "Please edit your details and submit form for futher processing.",
            showConfirmButton: true,
            confirmButtonColor: '#0E2F4F'
          })
          navigate('/mortgage_dashboard');
        }
      } else {
        console.error("Unexpected response from server", result);
      }
    } catch (error) {
      console.error("Post API error:", error);
    }
  };

  const excludedKeys = ['id', 'userId', 'createdAt', 'updatedAt', 'isActive', 'personalDetailsId', 'EmploymentDetailsId', 'ExpensesDetailsId', 'emiDetailsId', 'formId'];

  const formattedKeys = (key) => {
    const lowerWithSpaces = key.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    return lowerWithSpaces.charAt(0).toUpperCase() + lowerWithSpaces.slice(1);
  };

  const renderData = (data) => {
    if (typeof data === 'object' && data !== null) {
      return Object.entries(data).map(([key, value], index) => {
        if (Array.isArray(value)) {
          return value.map((item, index) => excludedKeys.includes(key) ? null : (
            <div key={index} className="nested-array">
              <div className="sub-heading"><h3>{index + 1}. {formattedKeys(key)} :</h3></div>
              {renderData(item)}
            </div>
          ));
        }
        if (typeof value === 'object' && value !== null) {
          return Object.entries(value).map(([key1, value1], index) => excludedKeys.includes(key1) ? null : (
            <>
              <div key={index} className="nested-object">
                <div className="label">{formattedKeys(key1)} :</div>
                <div className="value">{renderData(value1)}</div>

              </div>
            </>
          ));
        }
        return excludedKeys.includes(key) ? null : (
          <>
            <div key={index} className="nested-object">
              <div className="label">{formattedKeys(key)} :</div>
              <div className="value">{renderData(value)}</div>
            </div>
          </>
        )
      });
    } else {
      return <span>{data != null ? data.toString() : 'N/A'}</span>;
    }
  };

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="final-report">
        <h1>Final Report</h1>
        <div className="mortgage-enquiry">
          <>
            <h2>Loan Details</h2>
            <div className="details-table">
              {renderData(requirementData)}
            </div>
          </>
        </div>
        {Object.entries(data).map(([key, value], index) => (
          <div key={index} className="mortgage-enquiry">
            <h2>{formattedKeys(key)}</h2>
            <div className="details-table">
              {renderData(value)}
            </div>
          </div>
        ))}
      </div>
      <div className="buttons-div">
        <ButtonComponent name='Edit' onClick={saveFormData} />
        <ButtonComponent label="Submit" name='Submit' onClick={handleFormSubmission} />
      </div>
    </>

  );
};

export default FinalReport;